import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Tooltip } from "primereact/tooltip";
import moment from "moment";

function ActionCards({ approvalList = [], attendanceList = [], role = "employee", managerDashboardReload }) {
  const navigate = useNavigate();

  const MgrActionCardTimesheet = attendanceList.slice(0, 3).map((el, index) => {
    const formattedDates = el?.Attendances.map(item => moment(item.date).format("DD-MM-YYYY"));
    return (
      <Fragment>
        <div key={'mact' + index} className={classNames("col-4", "ess-act-card", "ess-card-theam-" + (index + 1))}>
          <div className="ess-act-header">
            <strong>Approval Pending</strong>
          </div>
          <div className="ess-act-body">
            <div className="container">
              <p><strong className="capitalize"> {el.firstName + " " + el.lastName} </strong>
                {" "}
                Requested Attendance Regularization for
              </p>
              <div className="card-date">
                <div>
                  <strong className={"custom-tooltip-btn-" + index}> {el?.Attendances?.length}   {el?.Attendances?.length > 1 ? "Days" : "Day"} <i className="pi pi-info-circle"></i></strong>
                  <Tooltip target={".custom-tooltip-btn-" + index}>
                    {
                      formattedDates?.filter((i, index) => (index < 10)).map((i, index) => {
                        return (
                          <>
                            <p> {i}  </p>
                            <p>{index > 8 ? "... To see more. Click on Review & Approve Now" : ''}</p>
                          </>
                        )
                      })
                    }
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="ess-act-footer">
              {/* <div style={{ float: 'left' }}>
                <a href='#' className='m-link' onClick={() => navigateTimeLine(el)}>View Timeline<i className="pi pi-arrow-up-right"></i></a>
              </div> */}
              {el.Allocation && (
                <div style={{ float: "left" }}></div>
              )}
              <div style={{ textAlign: "right" }}>
                <Button label="Review & Approve Now" className="p-button-sm p-button-rounded" onClick={() => navigate("/attendance?action=app&id=" + el.id + "&status=REVIEW")} />

              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  });

  return (
    <Fragment>
      <div className="grid">
        {MgrActionCardTimesheet}
      </div>
    </Fragment>
  );
}

export default ActionCards;